import { combineClassNames } from '@arkestro/arkestro-design-system';

import { LayoutContextData } from '@providers/LayoutProvider/LayoutProvider';
import styles from '@components/bid_request/details/StickyHeader/StickyHeader.module.scss';

export const getHeaderClassName = (
  isSticky: boolean,
  layout: LayoutContextData,
  isImpersonating = false
) => {
  if (!isSticky) return styles.stickyLotHeader;
  const sidebar = layout.collapsed ? styles.sidebarCollapsed : styles.sidebarExpanded;
  const impersonating = isImpersonating ? styles.impersonating : '';

  return combineClassNames(styles.stickyLotHeader, styles.scrolled, sidebar, impersonating);
};
